/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Connection } from "./modelConnection";

class ControllerConnection extends ControllerModel {
  constructor() {
    super("ControllerConnection");
    
    this.setNewNode = (x, y, ParentId, color, callback) => {
      let conn = new Connection(x, y, ParentId, color);
      conn.decorate(callback);
      this.addNode(conn);
      return conn;
    }

    this.isAlive = function(node){
      return document.querySelectorAll("#dot-" + node.id).length ? true : false
    }

    this.loadNode = (node, callback, createByParent) => {
      if(createByParent){
        let conn = new Connection(node.x, node.y, node.parentId, node.color)
        conn.copyFrom(node);
        conn.decorate(callback);
        this.addNode(conn);
        return conn
      }
    }
    
    this.loadCopiedNode = () =>{
      
    }

    this.getProperties = async (node) => {
      let n = new Connection();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Connection();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerConnection };
